import { ISnowWebcam } from 'api/home/types';
import { IResortPathInfo } from 'api/resort/types';
import { CameraList } from 'components/resort/CameraList';
import { NextLink } from 'components/blocks/NextLink';
import React from 'react';
import cameraListStyles from 'components/resort/CameraList/styles.module.scss';
import { Routes } from 'routes';
import styles from './styles.module.scss';

type HeaderScope = 'h1' | 'h2';

export const SnowWebcams = ({
  snowWebcams,
  header,
  showSnowReport,
  showSummitDepth,
  imageLink,
  titleLink,
  isFresh,
  headerScope = 'h2',
  hasMostReportedSnowfall = false,
  currentRegionSlug,
}: {
  headerScope?: HeaderScope;
  isFresh: boolean;
  snowWebcams: Array<ISnowWebcam>,
  header?: string,
  showSummitDepth?: boolean;
  showSnowReport?: boolean;
  imageLink?: (r: IResortPathInfo) => string,
  titleLink?: (r: IResortPathInfo) => string,
  hasMostReportedSnowfall?: boolean,
  currentRegionSlug?: string,
}) => {
  const headerTitle = React.createElement(headerScope, { className: styles.title }, header);

  const maxCameraCount = hasMostReportedSnowfall ? 4 : 6;
  const cameras = snowWebcams
    .slice(0, maxCameraCount)
    .map((item) => ({
      ...item.webcam,
      resort: item.resort,
    }));

  const cameraListClassName = hasMostReportedSnowfall ? undefined : cameraListStyles.threeColumns;

  // @ts-ignore
  const camsUrl = currentRegionSlug ? Routes.regionCams({ slug: currentRegionSlug }) : undefined;

  return (
    <section className={styles.snowWebcams}>
      {header && (
        <div className={styles.header}>
          {headerTitle}
          {camsUrl && (
          <div className={styles.btn}>
            <NextLink href={camsUrl}>View all cams</NextLink>
          </div>
          )}
        </div>
      )}
      <CameraList
        skipSingleCamera={false}
        isFresh={isFresh}
        imageLink={imageLink}
        titleLink={titleLink}
        showSnowReport={showSnowReport}
        showSummitDepth={showSummitDepth}
        className={cameraListClassName}
        cameras={cameras}
      />
    </section>
  );
};
